<template>
  <v-container grid-list-xl fluid="true" class="ma-0 pa-0">
    <v-layout row wrap>

      <v-flex xs12>
        <h2>Proveedores</h2>

        <div class="add-provider">
          <h2>Add a new provider</h2>

          <div>
            <v-btn color="secondary" @click="addProvider($event, 'ProviderFormClockify')">Clockify</v-btn>
            <v-btn color="secondary" @click="addProvider($event, 'ProviderFormYoutrack')">Youtrack</v-btn>
            <v-btn color="secondary" @click="addProvider($event, 'ProviderFormJira')">Jira</v-btn>
          </div>

          <component :is="currentProviderForm"/>
          <v-btn color="primary" v-if="currentProviderForm !== null" @click="currentProviderForm = null">Cancel</v-btn>
        </div>


      </v-flex>

      <v-flex xs12 class="registered-providers">
        <h2>Proveedores registrados</h2>

        <pre>{{ registeredProviders }}</pre>
      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import ProviderFormClockify from '@/components/add-provider-forms/Clockify'
import ProviderFormYoutrack from '@/components/add-provider-forms/Youtrack'
import ProviderFormJira from '@/components/add-provider-forms/Jira'
import { mapState } from "vuex";
import rest from "@/plugins/rest";

export default {
  components: {
    ProviderFormClockify,
    ProviderFormYoutrack,
    ProviderFormJira,
  },

  data() {
    return {
      registeredProviders: [],
      currentProviderForm: null
    }
  },

  methods: {

    addProvider($event, componentId) {
      this.currentProviderForm = componentId
    },

    getProviders() {
      const self = this

      rest.getProviders().then(r => {
        self.registeredProviders = r
      })
    },

  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
  },

  mounted: function () {
    this.getProviders()
  },


}
</script>

<style lang="scss" scoped>
.add-provider {
  border: 3px solid purple;
}

.registered-providers {
  border: 3px solid #369;
}
</style>